import documentation from './documentation';

export default {
  documentation,
};
